if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        this.skipCart = false;
        const variantInput = this.form.querySelector('[name=id]');
        console.log('Variant input:', variantInput);
        console.log('Variant input dataset:', variantInput?.dataset);
        console.log('Skip cart dataset:', variantInput?.dataset?.skipCart);
        if (variantInput?.dataset?.skipCart === 'true') {
          this.skipCart = true;
          console.log('Skip cart enabled');
        }

        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cartState) => {
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(
                `${routes.cart_add_url}`,
                this.getUpsellProductConfig()
              );
            }
          })
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })

          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (this.skipCart) {
              console.log('Redirecting to checkout');
              window.location = "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append("id", this.upsellVariantId);
        upsellFormData.append("quantity", 1);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}

(() => {
  function getActiveTieredQuantity(productRoot) {
    const activeButton = productRoot.querySelector(
      ".tiered-quantity-selector .tiered-option--active"
    );
    return parseInt(activeButton?.dataset.quantity, 10) || 1;
  }

  document.addEventListener(
    "click",
    (event) => {
      const atcButton = event.target.closest('button[name="add"]');
      if (!atcButton) return;

      const productRoot = atcButton.closest(".product") || document;
      const activeButton = productRoot.querySelector(
        ".tiered-quantity-selector .tiered-option--active"
      );
      if (!activeButton) return;

      const quantity = getActiveTieredQuantity(productRoot);
      if (quantity > 1) return;

      const tieredRoot = activeButton.closest(".tiered-quantity-selector");
      const quantityInputId = tieredRoot
        ?.querySelector(".tiered-quantity-options")
        ?.dataset.quantityInputId;
      const tieredQuantityInput = quantityInputId
        ? document.getElementById(quantityInputId)
        : null;
      const productForm = atcButton.closest("product-form");
      const formQuantityInput = productForm?.querySelector('form [name="quantity"]');

      activeButton.dataset.variantIds = "";
      if (tieredQuantityInput) tieredQuantityInput.value = "1";
      if (formQuantityInput) formQuantityInput.value = "1";
      atcButton.disabled = false;
      atcButton.removeAttribute("aria-busy");
      event.stopImmediatePropagation();
    },
    true
  );
})();

(() => {
  const PRODUCT_DATA_CACHE = new WeakMap();
  const USER_VALUE_ATTR = "data-tiered-user-value";

  function getProductData(root) {
    if (!PRODUCT_DATA_CACHE.has(root)) {
      PRODUCT_DATA_CACHE.set(
        root,
        fetch(`${root.dataset.productUrl}.js`).then((response) => {
          if (!response.ok) throw new Error("Product data unavailable");
          return response.json();
        })
      );
    }
    return PRODUCT_DATA_CACHE.get(root);
  }

  function getProductForm(root) {
    const productRoot = root.closest(".product") || document;
    return productRoot.querySelector("product-form");
  }

  function showTieredError(root, message) {
    const productForm = getProductForm(root);
    if (productForm && typeof productForm.handleErrorMessage === "function") {
      productForm.handleErrorMessage(message);
    }
  }

  function getSelectedOptions(row) {
    return Array.from(row.querySelectorAll("[data-tiered-unit-option]")).map(
      (select) => select.value
    );
  }

  function findVariant(productData, selectedOptions) {
    return productData.variants.find(
      (variant) =>
        variant.available !== false &&
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    );
  }

  function hasAvailableVariant(productData, row, selectIndex, candidateValue) {
    const currentOptions = getSelectedOptions(row);
    currentOptions[selectIndex] = candidateValue;

    return productData.variants.some((variant) => {
      if (variant.available === false) return false;
      return variant.options.every((optionValue, index) => {
        return optionValue === currentOptions[index];
      });
    });
  }

  function preserveUserValues(row) {
    row.querySelectorAll("[data-tiered-unit-option]").forEach((select) => {
      const userValue = select.getAttribute(USER_VALUE_ATTR);
      if (userValue && select.value !== userValue) {
        const matchingOption = Array.from(select.options).find(
          (option) => option.value === userValue && !option.disabled
        );
        if (matchingOption) select.value = userValue;
      }
    });
  }

  function updateRowAvailability(productData, row) {
    preserveUserValues(row);
    const selects = Array.from(row.querySelectorAll("[data-tiered-unit-option]"));

    selects.forEach((select, selectIndex) => {
      Array.from(select.options).forEach((option) => {
        option.disabled = !hasAvailableVariant(
          productData,
          row,
          selectIndex,
          option.value
        );
      });

      if (select.selectedOptions[0]?.disabled) {
        const firstAvailable = Array.from(select.options).find(
          (option) => !option.disabled
        );
        if (firstAvailable) {
          select.value = firstAvailable.value;
          select.setAttribute(USER_VALUE_ATTR, firstAvailable.value);
        }
      }
    });

    const selectedVariant = findVariant(productData, getSelectedOptions(row));
    row.classList.toggle("tiered-unit-row--unavailable", !selectedVariant);
    return selectedVariant;
  }

  async function updateActiveTieredWrapper(root) {
    const activeButton = root.querySelector(".tiered-option--active");
    if (!activeButton) return { quantity: 1, ids: [], valid: true };

    const quantity = parseInt(activeButton.dataset.quantity, 10) || 1;
    const wrapper = activeButton.closest(".tiered-option-wrapper");
    const selectors = wrapper?.querySelector("[data-tiered-unit-selectors]");
    if (quantity < 2 || !selectors) {
      activeButton.dataset.variantIds = "";
      return { quantity, ids: [], valid: true };
    }

    const productData = await getProductData(root);
    const ids = [];
    let valid = true;

    selectors.querySelectorAll("[data-tiered-unit-row]").forEach((row) => {
      const selectedVariant = updateRowAvailability(productData, row);
      if (selectedVariant) {
        ids.push(selectedVariant.id);
      } else {
        valid = false;
      }
    });

    activeButton.dataset.variantIds = valid ? ids.join(",") : "";
    return { quantity, ids, valid: valid && ids.length === quantity };
  }

  function initTieredRoot(root) {
    if (!root || root.dataset.tieredBundleGuardInitialized === "true") return;
    root.dataset.tieredBundleGuardInitialized = "true";

    root.querySelectorAll("[data-tiered-unit-option]").forEach((select) => {
      select.setAttribute(USER_VALUE_ATTR, select.value);
      select.addEventListener("change", async () => {
        select.setAttribute(USER_VALUE_ATTR, select.value);
        await updateActiveTieredWrapper(root);
      });
    });

    getProductData(root)
      .then(() => updateActiveTieredWrapper(root))
      .catch(() => {});

    document.addEventListener("variant:change", () => {
      setTimeout(() => {
        root.querySelectorAll("[data-tiered-unit-row]").forEach(preserveUserValues);
        updateActiveTieredWrapper(root);
      }, 0);
    });

    const productRoot = root.closest(".product") || document;
    const atcButton = productRoot.querySelector('button[name="add"]');
    if (!atcButton || atcButton.dataset.tieredBundleGuardClick === "true") return;
    atcButton.dataset.tieredBundleGuardClick = "true";

    atcButton.addEventListener(
      "click",
      async (event) => {
        const activeRoot = productRoot.querySelector(
          ".tiered-quantity-selector .tiered-option--active"
        )?.closest(".tiered-quantity-selector");
        if (!activeRoot) return;

        const activeButton = activeRoot.querySelector(".tiered-option--active");
        const quantity = parseInt(activeButton?.dataset.quantity, 10) || 1;
        if (quantity < 2) {
          if (activeButton) activeButton.dataset.variantIds = "";
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const productForm = getProductForm(activeRoot);
        const spinner = atcButton.querySelector(".loading__spinner");
        const cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        atcButton.classList.add("loading");
        atcButton.disabled = true;
        atcButton.setAttribute("aria-busy", "true");
        if (spinner) spinner.classList.remove("hidden");
        if (productForm && typeof productForm.handleErrorMessage === "function") {
          productForm.handleErrorMessage();
        }

        try {
          const result = await updateActiveTieredWrapper(activeRoot);
          if (!result.valid) {
            showTieredError(
              activeRoot,
              "Please choose available options for every item in the bundle."
            );
            return;
          }

          const items = result.ids.map((id) => ({ id: Number(id), quantity: 1 }));
          const sections = cart
            ? cart.getSectionsToRender().map((section) => section.id)
            : [];

          const response = await fetch(
            `${window.Shopify.routes.root || "/"}cart/add.js`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                items,
                sections,
                sections_url: window.location.pathname,
              }),
            }
          );
          const responseData = await response.json();

          if (!response.ok) {
            showTieredError(
              activeRoot,
              responseData.description || responseData.message
            );
            return;
          }

          if (cart) {
            cart.renderContents(responseData);
            if (cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
            if (cart.tagName.toLowerCase() === "cart-drawer") cart.open();
          } else {
            window.location.href = `${window.Shopify.routes.root || "/"}cart`;
          }
        } catch (error) {
          showTieredError(
            activeRoot,
            "Please choose available options for every item in the bundle."
          );
        } finally {
          atcButton.classList.remove("loading");
          atcButton.disabled = false;
          atcButton.setAttribute("aria-busy", "false");
          if (spinner) spinner.classList.add("hidden");
        }
      },
      true
    );
  }

  function initTieredBundleGuard() {
    document
      .querySelectorAll(".tiered-quantity-selector[data-product-url]")
      .forEach(initTieredRoot);
  }

  document.addEventListener("DOMContentLoaded", initTieredBundleGuard);
  document.addEventListener("shopify:section:load", initTieredBundleGuard);
})();
